import React, { useState } from 'react';
import cx from 'clsx';
import Icon from '../Icon/Icon';
import colors from '../../util/colors';
import { Anchor } from '../../util/types';
import Dropdown from '../Dropdown/Dropdown';
import classes from './UserIcon.module.scss';

export interface UserIconProps extends React.HTMLProps<HTMLDivElement> {
  menuItems?: { fields: Anchor }[],
  iconSize?: number,
  iconColor?: string,
  iconBackground?: string,
}

export default function UserIcon({
  className,
  menuItems = [],
  iconSize = 10,
  iconColor = colors.teal,
  iconBackground = colors.purple,
  ...others
}: UserIconProps) {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className={cx(classes.userIcon, className)} {...others}>
      <button
        type="button"
        className={classes.userButton}
        style={{ backgroundColor: iconBackground }}
        onClick={() => setShowDropdown(!showDropdown)}
        aria-label="User menu"
      >
        <Icon icon="user" className={classes.userIcon} size={iconSize} fill={iconColor} />
      </button>
      <Dropdown
        opened={showDropdown}
        onClose={() => setShowDropdown(false)}
        childList={menuItems.map(item => ({ ...item.fields, isLink: !!item.fields.href }))}
        hideTopBorder
        className={classes.dropDown}
      />
    </div>
  );
}

UserIcon.displayName = '@ioa/lablocator/UserIcon';
